var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delay } from '@xyo-network/sdk-xyo-js';
import global from '../../global';
class BaseEvent {
    constructor(name, param) {
        this.name = name;
        this.param = param;
        this.dcq = this.getDcq();
        this.dcs = this.getDcs();
    }
    send(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = [this.name];
            if (this.param) {
                payload.push(this.param);
            }
            payload.push(data);
            this.dcq.push(payload);
            yield delay(0);
        });
    }
    getDcq() {
        if (!global._dcq) {
            throw Error('DCQ not found');
        }
        return global._dcq;
    }
    getDcs() {
        if (!global._dcs) {
            throw Error('DCS not found');
        }
        return global._dcs;
    }
}
export default BaseEvent;
//# sourceMappingURL=BaseEvent.js.map